import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageService } from "@obg/ngx.core";
import { groupSwitchMap } from "@obg/ngx.global";
import { merge, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { CONTENT_SECTION_ACTION_TYPE, ContentSectionAction } from "./content-section.action";
import { contentSectionMessageContext } from "./content-section.const";
import { ContentSectionService } from "./content-section.service";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable()
export class ContentSectionEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getContentSectionGroup) instead
	 */
	get$ = createEffect(() =>
		this.actions$.pipe(
			ofType(CONTENT_SECTION_ACTION_TYPE.get),
			map((x: ActionWithPayload<string>) => x.payload),
			groupSwitchMap((name) =>
				this.service.get(name).pipe(
					map((response) => this.action.getSuccess(response, name)),
					catchError((error: AppError) => of(this.action.getFail(error)))
				)
			)
		)
	);

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$({
				[CONTENT_SECTION_ACTION_TYPE.getFail]: contentSectionMessageContext.get,
			}),
			this.messageService.mapClearByContext$({
				[CONTENT_SECTION_ACTION_TYPE.get]: contentSectionMessageContext.get,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private action: ContentSectionAction,
		private service: ContentSectionService,
		private messageService: MessageService
	) {}
}
